import { useQuery } from '@betterment/js-runtime';

import FirmFormCRSModal from './FirmFormCRSModal';
import FormCRSModal from './FormCRSModal';

type FormCRSNotificationData = {
  shouldShowFormCrsNotification: boolean;
  shouldShowFirmFormCrsNotification: boolean;
  firmFormCrsName: string | null;
  firmFormCrsDocumentUrl: string | null;
  firmFormCrsToken: string | null;
};

const HomeModal: React.FC = () => {
  const { data } = useQuery<FormCRSNotificationData>('/api/v2/form_crs_notification');

  if (!data) return null;

  return (
    <>
      {data.shouldShowFormCrsNotification && <FormCRSModal />}
      {data.shouldShowFirmFormCrsNotification && (
        <FirmFormCRSModal
          firmFormCRSName={data.firmFormCrsName!}
          firmFormCRSDocumentURL={data.firmFormCrsDocumentUrl!}
          firmFormCRSToken={data.firmFormCrsToken!}
        />
      )}
    </>
  );
};

export default HomeModal;
